import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface GeneratePdfRecordState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allPdfRecord: [] | null | any;
}
const initialState: GeneratePdfRecordState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allPdfRecord: null
};
export const pdfRecordSlice = createSlice({
  name: 'pdfRecord',
  initialState,
  reducers: {
    setPdfReords: (state, action) => {
      state.allPdfRecord = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setPdfReords, reset } = pdfRecordSlice.actions;
export const allPdfRecordDetails = (state: RootState) => state.pdfRecord.allPdfRecord;
export const pdfRecordTotalRecords=(state:RootState)=>state.pdfRecord.totalRecords;
export default pdfRecordSlice.reducer;